import { render, staticRenderFns } from "./admin_tag_select.vue?vue&type=template&id=11e2a44d&scoped=true"
import script from "./admin_tag_select.vue?vue&type=script&lang=js"
export * from "./admin_tag_select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11e2a44d",
  null
  
)

export default component.exports